import { Button, Form, Input } from 'antd';
import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { IFormProps } from '../../../typings';

export function SendNewPasswordCodeForm({ loading = false, ...rest }: IFormProps) {
  const { t } = useTranslation();

  return (
    <Form {...rest} layout="vertical">
      <Form.Item
        name="email"
        label={t('EMAIL_LABEL')}
        labelAlign="left"
        rules={[
          {
            required: true,
            type: 'email',
          },
        ]}
        hasFeedback
      >
        <Input />
      </Form.Item>
      <Form.Item style={{ textAlign: 'center' }}>
        <Button type="primary" loading={loading} htmlType="submit" block>
          {t('SUBMIT_BUTTON')}
        </Button>
      </Form.Item>
    </Form>
  );
}
